import React from "react";
import './call-badges.scss'

const ScheduledNextCall = () => (
  <span className='call-outcome-scheduled-call'>
    <p>Next call</p>
  </span>
)

export default ScheduledNextCall;